import React from 'react';
import { Package, Store, RefreshCw, AlertTriangle, BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModernModuleDashboard from '../../shared/components/dashboard/ModernModuleDashboard';
import {
  buildDashboardCharts,
  withKpiVariants,
} from '../../shared/components/dashboard/moduleDashboardCharts';
import { formatBrandMoney } from '../../shared/utils/brandCurrency';

export default function InventoryDashboardPage() {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.inventaire.pages.dashboardPage.${key}`, opts);

  return (
    <ModernModuleDashboard
      apiEndpoint="/inventaire/dashboard"
      title={p('title', { defaultValue: 'لوحة تحكم المخزون' })}
      subtitle={p('subtitle', { defaultValue: 'مؤشرات المستودعات والحركات' })}
      icon={Package}
      accent="from-emerald-600 to-green-800"
      recentTitle={p('recent_movements', { defaultValue: 'آخر الحركات' })}
      quickLinks={[
        { label: p('link_warehouses', { defaultValue: 'المستودعات' }), href: '/warehouses', icon: Store },
        { label: p('link_movements', { defaultValue: 'حركات المخزون' }), href: '/mouvements-stock', icon: RefreshCw },
        { label: p('link_transfers', { defaultValue: 'التحويلات' }), href: '/transferts', icon: RefreshCw },
        { label: p('link_analytics', { defaultValue: 'التحليلات' }), href: '/inventaire/analyses-rapports', icon: BarChart3 },
      ]}
      mapData={(data) => {
        const kpis = data.kpis || {};
        const chartRows = data.chartRows || [];

        return {
          hero: {
            label: p('kpi_stock_value', { defaultValue: 'قيمة المخزون' }),
            value: formatBrandMoney(kpis.totalValue || 0),
            icon: Package,
          },
          kpis: withKpiVariants([
            { label: p('kpi_stock_value', { defaultValue: 'قيمة المخزون' }), value: formatBrandMoney(kpis.totalValue || 0), icon: Package },
            { label: p('kpi_movements_today', { defaultValue: 'حركات اليوم' }), value: kpis.movementsToday ?? 0, icon: RefreshCw },
            { label: p('kpi_active_warehouses', { defaultValue: 'مستودعات نشطة' }), value: kpis.activeWarehouses ?? kpis.warehouses ?? 0, icon: Store },
            { label: p('kpi_low_stock', { defaultValue: 'تنبيهات المخزون' }), value: kpis.lowStock ?? 0, icon: AlertTriangle },
          ]),
          charts: buildDashboardCharts({
            ranked: {
              title: p('chart_movements_30d', { defaultValue: 'حركات المخزون — 30 يومًا' }),
              subtitle: p('chart_movements_30d_subtitle', { defaultValue: 'عدد الحركات اليومية' }),
              alwaysShow: true,
              rows: data.movementTrend30Days || [],
            },
            status: {
              title: p('chart_status_title', { defaultValue: 'حالة المستودعات' }),
              subtitle: p('chart_status_subtitle', { defaultValue: 'نشطة مقابل غير نشطة' }),
              active: kpis.activeWarehouses ?? kpis.warehouses ?? 0,
              inactive: Math.max(0, (kpis.warehouses ?? 0) - (kpis.activeWarehouses ?? kpis.warehouses ?? 0)),
              alwaysShow: true,
            },
            pipeline: {
              title: p('chart_warehouses', { defaultValue: 'توزيع المخزون بالمستودعات' }),
              subtitle: p('chart_warehouses_subtitle', { defaultValue: 'حسب مستوى المخزون' }),
              alwaysShow: true,
              rows: chartRows,
            },
          }),
          recentItems: data.recentItems || [],
        };
      }}
    />
  );
}
